import React, { useEffect } from "react";
import { Modal, Col, Row } from "antd";
import CaseSummaryPerson from "../case-summary/case-summary-person";
import CaseSummaryCase from "../case-summary/case-summary-case";
import CaseBalanceViolationCase from "./case-balance-violation-case";
import CaseBalancePenaltyCase from "./case-balance-penalty-case";

const CaseBalanceViolationModal = ({ ...props }) => {
  const { isModalOpen, setIsModalOpen, violationDetails, form } = props;

  useEffect(() => {
    form.setFieldsValue({ ...violationDetails });
  }, [violationDetails, form]);

  return (
    <Modal visible={isModalOpen} title="Violation Case Details" onCancel={() => setIsModalOpen(false)} width={1000} cancelText="Close" okButtonProps={{ style: { display: "none" } }}>
      <Row gutter={[12, 12]}>
        <Col xl={12} lg={12} md={24} sm={24} xs={24}>
          <CaseSummaryPerson form={form} violationDetails={violationDetails} />
        </Col>
        <Col xl={12} lg={12} md={24} sm={24} xs={24}>
          <CaseSummaryCase form={form} />
        </Col>
        <Col xl={12} lg={12} md={24} sm={24} xs={24}>
          <CaseBalanceViolationCase form={form} />
        </Col>
        <Col xl={12} lg={12} md={24} sm={24} xs={24}>
          <CaseBalancePenaltyCase form={form} />
        </Col>
      </Row>
    </Modal>
  );
};

export default CaseBalanceViolationModal;
